/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleWithQuantityRequest } from './APIArticleWithQuantityRequest';
import {
    APIArticleWithQuantityRequestFromJSON,
    APIArticleWithQuantityRequestFromJSONTyped,
    APIArticleWithQuantityRequestToJSON,
} from './APIArticleWithQuantityRequest';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * Enables including one or more articles in the Request creation.
 * Supports:
 * - Single article (backward compatibility)
 * - Multiple articles (articles array)
 * - Articles with quantities (articles_with_quantities array)
 * @export
 * @interface APIRequestCreationRequest
 */
export interface APIRequestCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    article?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestCreationRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    contact?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestCreationRequest
     */
    isTemp?: boolean;
    /**
     * Calculated costs listed together with quantities as JSON object like {'100': '100', '200': '200', ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreationRequest
     */
    calculatedCosts?: { [key: string]: any; };
    /**
     * Detailed calculated costs per quantity written down as JSON object like {'100': {'estimated_price': '€ 10.00', 'estimated_material_cost': '€ 2.00', ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreationRequest
     */
    calculatedCostBreakdown?: { [key: string]: any; };
    /**
     * The costs per quantity reported by suppliers written down as JSON object like {'supplier_1': {quantity_1: price_1, quantity_2: price_2, ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreationRequest
     */
    reportedCosts?: { [key: string]: any; };
    /**
     * Optional price suggestion provided by the customer.
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    customerPriceSuggestion?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestCreationRequest
     */
    wishDate?: Date | null;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIRequestCreationRequest
     */
    status: APIPlanningEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestCreationRequest
     */
    priority?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    certificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreationRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestCreationRequest
     */
    articles?: Array<string>;
    /**
     * 
     * @type {Array<APIArticleWithQuantityRequest>}
     * @memberof APIRequestCreationRequest
     */
    articlesWithQuantities?: Array<APIArticleWithQuantityRequest>;
}



/**
 * Check if a given object implements the APIRequestCreationRequest interface.
 */
export function instanceOfAPIRequestCreationRequest(value: object): value is APIRequestCreationRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function APIRequestCreationRequestFromJSON(json: any): APIRequestCreationRequest {
    return APIRequestCreationRequestFromJSONTyped(json, false);
}

export function APIRequestCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'article': json['article'] == null ? undefined : json['article'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'contact': json['contact'] == null ? undefined : json['contact'],
        'isTemp': json['is_temp'] == null ? undefined : json['is_temp'],
        'calculatedCosts': json['calculated_costs'] == null ? undefined : json['calculated_costs'],
        'calculatedCostBreakdown': json['calculated_cost_breakdown'] == null ? undefined : json['calculated_cost_breakdown'],
        'reportedCosts': json['reported_costs'] == null ? undefined : json['reported_costs'],
        'customerPriceSuggestion': json['customer_price_suggestion'] == null ? undefined : json['customer_price_suggestion'],
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'status': APIPlanningEnumFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'certificate': json['certificate'] == null ? undefined : json['certificate'],
        'description': json['description'] == null ? undefined : json['description'],
        'articles': json['articles'] == null ? undefined : json['articles'],
        'articlesWithQuantities': json['articles_with_quantities'] == null ? undefined : ((json['articles_with_quantities'] as Array<any>).map(APIArticleWithQuantityRequestFromJSON)),
    };
}

export function APIRequestCreationRequestToJSON(value?: APIRequestCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'article': value['article'],
        'editors': value['editors'],
        'contact': value['contact'],
        'is_temp': value['isTemp'],
        'calculated_costs': value['calculatedCosts'],
        'calculated_cost_breakdown': value['calculatedCostBreakdown'],
        'reported_costs': value['reportedCosts'],
        'customer_price_suggestion': value['customerPriceSuggestion'],
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate'] as any).toISOString().substring(0,10)),
        'status': APIPlanningEnumToJSON(value['status']),
        'priority': value['priority'],
        'remarks': value['remarks'],
        'certificate': value['certificate'],
        'description': value['description'],
        'articles': value['articles'],
        'articles_with_quantities': value['articlesWithQuantities'] == null ? undefined : ((value['articlesWithQuantities'] as Array<any>).map(APIArticleWithQuantityRequestToJSON)),
    };
}

